var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#D7C0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 15.3333V16.6666C6.6665 17.0202 6.80698 17.3594 7.05703 17.6094C7.30708 17.8595 7.64622 18 7.99984 18H15.9998C16.3535 18 16.6926 17.8595 16.9426 17.6094C17.1927 17.3594 17.3332 17.0202 17.3332 16.6666V15.3333M8.6665 9.99996L11.9998 6.66663M11.9998 6.66663L15.3332 9.99996M11.9998 6.66663V14.6666",
    stroke: "#6000E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.7f1d6ad7e11e2dda8b90628ca78c010d.svg";
export { ForwardRef as ReactComponent };